import { render, staticRenderFns } from "./MedicalDataEdit.vue?vue&type=template&id=136714d0&scoped=true&"
import script from "./MedicalDataEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136714d0",
  null
  
)

export default component.exports